<h1 class="mb-4 wizard-h1">{{ "welcome2_title" | translate }}</h1>
<p class="mb-12">{{ "welcome2_text1" | translate }}</p>

<div class="grid grid-cols-12 gap-4">
    <div class="col-span-12 md:col-span-6 lg:col-span-4">
        <div class="p-fluid">
            <div class="field">
                <label id="labelCompanyName" for="companyName">
                    <strong>{{ "welcome2_companyName" | translate }}</strong>
                </label>
                <input
                    id="companyName"
                    [(ngModel)]="companyName"
                    autofocus
                    type="text"
                    class="p-inputtext-lg"
                    placeholder="{{ 'welcome2_companyName_placeholder' | translate }}"
                    pInputText
                />
            </div>
        </div>
    </div>
</div>

<div class="mb-6"></div>

<div class="grid grid-cols-12 gap-4">
    <div class="col-span-12 md:col-span-6 lg:col-span-4">
        <div class="p-fluid">
            <div class="field">
                <label id="labelCompanySize" for="companySize">
                    <strong>{{ "welcome2_companySize" | translate }} *</strong>
                </label>
                <p-select
                    size="large"
                    id="companySize"
                    [options]="companySizes"
                    optionLabel="name"
                    optionValue="code"
                    [(ngModel)]="companySize"
                    placeholder="{{ 'welcome2_companySize_placeholder' | translate }}"
                />
            </div>
        </div>
    </div>
</div>

<div class="mb-6"></div>

<div class="grid grid-cols-12 gap-4">
    <div class="col-span-12 md:col-span-6 lg:col-span-4">
        <div class="p-fluid">
            <div class="field">
                <label id="labelCompanySector" for="companySector">
                    <strong>{{ "welcome2_companySector" | translate }} *</strong>
                </label>
                <p-select
                    size="large"
                    id="companySector"
                    [options]="companySectors"
                    optionLabel="name"
                    optionValue="code"
                    [(ngModel)]="companySector"
                    placeholder="{{ 'welcome2_companySector_placeholder' | translate }}"
                />
            </div>
        </div>
    </div>
</div>

<div class="mb-12"></div>

<p-button [label]="'welcome2_button' | translate" (onClick)="goToNext()" [disabled]="!companySector || !companySize"></p-button>
